import { render, staticRenderFns } from "./ControlTable.vue?vue&type=template&id=6a45f1fb&scoped=true"
import script from "./ControlTable.vue?vue&type=script&lang=ts"
export * from "./ControlTable.vue?vue&type=script&lang=ts"
import style0 from "./ControlTable.vue?vue&type=style&index=0&id=6a45f1fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a45f1fb",
  null
  
)

export default component.exports